import { useEffect, useRef } from "react";

/**
 * Runs `reset` on mount and whenever the workspace switches to another Plan identity
 * (`shopId:planId`), so state from the previous Plan never leaks into the next one.
 */
export function usePlanIdentityReset(identity: string, reset: () => void): void {
  const resetRef = useRef(reset);
  resetRef.current = reset;
  const appliedIdentityRef = useRef<string | null>(null);
  useEffect(() => {
    if (appliedIdentityRef.current === identity) return;
    appliedIdentityRef.current = identity;
    resetRef.current();
  }, [identity]);
}
